export enum MeasureUnit {
    CURRENCY = 'CHF',
    SQUARE_METER = 'm²',
    CUBIC_METER = 'm³',
}
